import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "./../store";

const customFieldsMetadataItems = localStorage.getItem("customFieldsMetadataItem");
const initialState: any = {
  customFieldsMetadata: customFieldsMetadataItems ? JSON.parse(customFieldsMetadataItems):  null,
};
const customFieldsSlice = createSlice({
  name: "customFields",
  initialState,
  reducers: {
    setCustomFieldsMetadata: (state, action: PayloadAction<any>) => {
      state.customFieldsMetadata = action.payload;
      localStorage.setItem("customFieldsMetadataItem", JSON.stringify(action.payload));
    },
  },
});
export const { setCustomFieldsMetadata } = customFieldsSlice.actions;
export default customFieldsSlice.reducer;
export const customFieldMetadataItem = (state: RootState) =>
  state.customFields.customFieldsMetadata;
